
export default function WhatsAppButton() {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/97455544093', '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-50 animate-pulse"
      aria-label="Contact us on WhatsApp"
    >
      <div className="w-8 h-8 flex items-center justify-center">
        <i className="ri-whatsapp-line text-2xl"></i>
      </div>
    </button>
  );
}
